import * as React from 'react';
import { Box, Text, TextButton } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { AppContext } from '@src/context/store';
import { getKBLinks } from '@src/context/selectors/ui-settings';

export const TabsSubtitle = translate()(({ t }: InjectedTranslateProps) => {
  const store = React.useContext(AppContext);
  const onLearnMoreClicked = () => window.open(getKBLinks(store).AboutPrivacyCookies, '_blank');

  return (
    <Box>
      <Box marginRight={'6px'}>
        <Text>{t('root.page.subtitle')}</Text>
      </Box>
      <Box>
        <TextButton dataHook={DataHooks.SubtitleLearnMoreButton} onClick={onLearnMoreClicked}>
          {t('learn.more')}
        </TextButton>
      </Box>
    </Box>
  );
});
